import { render, staticRenderFns } from "./RemoveFriend.vue?vue&type=template&id=4504b968"
import script from "./RemoveFriend.vue?vue&type=script&lang=js"
export * from "./RemoveFriend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports